import { ComponentProps, useState } from "react";
import { getMoreNewsStoriesCardProps } from "@events-awards/utils/helpers";
import { fetchMoreStoriesData } from "@pages/Section/Section.server";
import Card from "@particles/card/Card";
import { sanitizeFeedSectionArticleObjects as sanitize } from "@util/sanitization/sanitizeFeedSectionArticleObjects";

export const useLoadMoreEventsNewsByKeywords = (
  initialList: ComponentProps<typeof Card>[],
  pageSize: number,
  uniqueCategoryQuery: string,
  parentCategory: string
) => {
  const [articleList, setMoreArticlesList] = useState(initialList);
  const [hasMoreArticles, setHasMoreArticles] = useState(
    initialList.length >= pageSize
  );

  const handleLoadMore = async () => {
    const page = articleList.length / pageSize + 1;

    if (articleList.length === 0) return;

    const newMoreArticles = await fetchMoreStoriesData(
      uniqueCategoryQuery,
      parentCategory,
      page
    );

    const sanitizedNewMoreArticles = sanitize(newMoreArticles);

    const feedArticleItems = getMoreNewsStoriesCardProps(
      sanitizedNewMoreArticles
    );

    if (feedArticleItems.length < pageSize) setHasMoreArticles(false);

    setMoreArticlesList((prev) => [...prev, ...feedArticleItems]);
  };

  return { articleList, handleLoadMore, hasMoreArticles };
};
